import { theme } from '../clientConfig';

// Maps the resolved per-client theme (see clientConfig.js) onto the CSS
// variables that App.css / index.css / tailwind.config.js read from.
//
// Called once at startup, before React renders, so there is no flash of the
// wrong brand colours. Keep the var names in sync with :root in App.css.
const CSS_VAR_MAP = {
  colors: {
    // --primary and --primary-button are used interchangeably across the app,
    // so drive both from the single `primary` colour.
    primary: ['--primary', '--primary-button'],
    secondary: ['--secondary'],
    tertiary: ['--tertiary'],
    // Light brand tints (backgrounds, borders). Optional per client.
    shades1: ['--shades1'],
    light: ['--light'],
  },
  fonts: {
    primary: ['--font-primary'],
    secondary: ['--font-secondary'],
  },
};

// Converts #rrggbb (or #rgb) to a comma-separated "r, g, b" string for use in
// rgba(var(--primary-button-rgb), <alpha>). Returns null for unparseable input.
function hexToRgbString(hex) {
  if (typeof hex !== 'string') return null;
  let h = hex.trim().replace(/^#/, '');
  if (h.length === 3) {
    h = h
      .split('')
      .map((c) => c + c)
      .join('');
  }
  if (h.length !== 6 || /[^0-9a-f]/i.test(h)) return null;
  const int = parseInt(h, 16);
  // eslint-disable-next-line no-bitwise
  return `${(int >> 16) & 255}, ${(int >> 8) & 255}, ${int & 255}`;
}

export default function applyTheme(activeTheme = theme) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;

  Object.entries(CSS_VAR_MAP).forEach(([group, keys]) => {
    Object.entries(keys).forEach(([key, cssVars]) => {
      const value = activeTheme?.[group]?.[key];
      if (value == null) return;
      cssVars.forEach((cssVar) => root.style.setProperty(cssVar, value));
    });
  });

  // rgb triplet of primary, for rgba(var(--primary-button-rgb), <alpha>) usages.
  const primaryRgb = hexToRgbString(activeTheme?.colors?.primary);
  if (primaryRgb) {
    root.style.setProperty('--primary-rgb', primaryRgb);
    root.style.setProperty('--primary-button-rgb', primaryRgb);
  }
}
